import React from 'react';
import { NavigationContextWrapper, ProviderContextWrapper, UserContextWrapper } from '~/Hooks';
import { ProviderFiltersContextWrapper } from '~/Hooks/useFilter/useProviderFilters';

export const ContextWrapper = ({ children }: { children: React.ReactNode }) => (
  <ProviderContextWrapper>
    <ProviderFiltersContextWrapper>
      <UserContextWrapper>
        <NavigationContextWrapper>{children}</NavigationContextWrapper>
      </UserContextWrapper>
    </ProviderFiltersContextWrapper>
  </ProviderContextWrapper>
);
